import React from "react";
import "./BookSessionTodayButton.css";
import booknow from "../assets/images/BookNow.png";

const BookSessionTodayButton = () => {
  return (
    <a href="#book-session-form" className="book-session-today-button">
      <img src={booknow} alt="Book a session" className="floating-button-image" />
    </a>
  );
};

export default BookSessionTodayButton;
